import { Component, Input } from '@angular/core';
import { InComplianceStatus } from '../enums/in-compliance-status.enum';

@Component({
    selector: 'in-compliance-status-indicator',
    templateUrl: './in-compliance-status-indicator.component.html',
    styleUrls: ['./in-compliance-status-indicator.component.scss']
})
export class InComplianceStatusIndicatorComponent {
    @Input() status: InComplianceStatus = InComplianceStatus.MISSING;

    InComplianceStatus = InComplianceStatus;
    
}
